/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Create_Account_TitleInputs */



/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Login_Create_Account_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_create_account_title = /** @type {((inputs?: Login_Create_Account_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Create_Account_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un Compte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerkonto erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creare un account")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Зарегистрироваться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear una cuenta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建账户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アカウントを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाता बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar uma conta")
	return /** @type {LocalizedString} */ ("Create Account")
});